import styled from 'styled-components'

import {
  DataTableHeaderCell,
  DataTableHeaderShell,
} from '@root/shared/ui-kit/data-table/ui'

import { FavoriteTableColumn } from '../desktop/favorite-pairs-table/favorite-table-columns'

import type {
  FavoritePairsTableColumn,
  FavoritePairsTableModel,
} from '../../atoms/reatom-favorite-pairs-table'
import type { FavoriteUnavailable } from '../../model/favorite-unavailable'
import type { PairModel } from '@root/entities/pair/atoms'
import type { Column } from '@root/shared/ui-kit/data-table/ui'

type FavoritePairsSortingProps = {
  model: FavoritePairsTableModel
}

const MarketCapColumn: Column<
  PairModel | FavoriteUnavailable,
  FavoritePairsTableColumn
> = {
  ...FavoriteTableColumn.MarketCap,
  justify: 'start',
}

const LiquidityColumn: Column<
  PairModel | FavoriteUnavailable,
  FavoritePairsTableColumn
> = {
  ...FavoriteTableColumn.Liquidity,
  justify: 'start',
}

const HoldingColumn: Column<
  PairModel | FavoriteUnavailable,
  FavoritePairsTableColumn
> = {
  ...FavoriteTableColumn.Holding,
  justify: 'center',
}

const PriceChangeColumn: Column<
  PairModel | FavoriteUnavailable,
  FavoritePairsTableColumn
> = {
  ...FavoriteTableColumn.PriceChange,
  justify: 'end',
}

export const FavoritePairsSorting: React.FC<FavoritePairsSortingProps> = ({
  model,
}) => {
  return (
    <Root>
      <DataTableHeaderCell
        column={MarketCapColumn}
        model={model}
        context={undefined}
        showInactiveSorting={true}
      />
      <DataTableHeaderCell
        column={LiquidityColumn}
        model={model}
        context={undefined}
        showInactiveSorting={true}
      />
      <DataTableHeaderCell
        column={HoldingColumn}
        model={model}
        context={undefined}
        showInactiveSorting={true}
      />
      <DataTableHeaderCell
        column={PriceChangeColumn}
        model={model}
        context={undefined}
        showInactiveSorting={true}
      />
    </Root>
  )
}

const Root = styled(DataTableHeaderShell)`
  position: static;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: space-between;
`
